import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Icon from '../../components/general/Icon'
import AccountNotifications from './AccountNotifications'
import { desktop, VIEWPORT_DESKTOP } from '../../styles/media'
import translate from '../../helper/translate'
import Link from '../../components/router/Link'
import CommentsDropDown from './CommentsDropDown'
import styled from 'styled-components'
import { getSuggestedCollection } from '../../helper/collection'
import { withRouter } from 'react-router-dom'
import { StyledUnread } from '../../components/general/Unread'

const SiteSettingsOld = ({ authToken, collections, location, subscribed, t, unreadComments, viewport }) => {
	const suggestedCollection = getSuggestedCollection(collections, 'wants')
	const suggestedCollectionData = collections?.find(collection => collection.slug === suggestedCollection)

	return authToken ? (
		<StyledSiteSettings>
			{viewport === VIEWPORT_DESKTOP && subscribed && (
				<SecondaryLink
					to={suggestedCollection ? `/collection/${suggestedCollection}` : '/mycollections/collection?type=wants'}
					title={suggestedCollection ? suggestedCollectionData.name : t('general.collectionTypeWants')}
					active={location.pathname === `/collection/${suggestedCollection}`}
				>
					<Icon name="heart" />
				</SecondaryLink>
			)}

			<CommentsDropDown
				button={(
					<SecondaryLink unread={unreadComments && unreadComments > 0} title={t('general.comments')}>
						<Icon name="chat-alt-2" />
						<AccountNotifications small type="comments" />
					</SecondaryLink>
				)}
			/>
		</StyledSiteSettings>
	) : null
}

SiteSettingsOld.propTypes = {
	authToken: PropTypes.string,
	collections: PropTypes.array,
	location: PropTypes.object.isRequired,
	subscribed: PropTypes.string,
	t: PropTypes.func.isRequired,
	unreadComments: PropTypes.number,
	viewport: PropTypes.string.isRequired
}

SiteSettingsOld.defaultProps = {
	authToken: null,
	collections: [],
	subscribed: null,
	unreadComments: null
}

const StyledSiteSettings = styled.div`
	align-items: center;
	display: flex;

	${desktop`
		border-right: 2px solid ${props => props.theme.id === 'dark' ? 'rgba(255, 255, 255, 0.1)' : props.theme.backgroundConcrete};
		margin-right: -0.5rem;
		padding-right: 0.5rem;
	`}
`

export const SecondaryLink = styled(Link)`
	display: flex;
	align-items: center;

	height: 40px;
	width: 40px;

	align-items: center;
	display: flex;
	justify-content: center;

	color: ${props => props.theme.textLight};
	text-decoration: none;
	transition: 0.1s;

	> span:not(${StyledUnread}) {
		margin: 0 0.25rem;
		white-space: nowrap;

		display: flex;
		flex-direction: column;
	}

	${StyledUnread} {
		position: absolute;
		right: -2px;
		top: -2px;
	}

	svg {
		height: 24px;
		width: 24px;
		min-width: 24px;
	}

	${props => props.active && `
		color: ${props.theme.text};
	`}

	${props => props.unread ? `
		background: rgba(0, 0, 0, 0.8);
		color: ${props.theme.white};
		border-radius: 50%;
	` : ''}

	${desktop`
		&:hover {
			color: ${props => props.unread ? props.theme.white : props.theme.text};
		}
	`}
`

const enhance = compose(
	connect(state => ({
		authToken: state.persist.authToken,
		collections: state.persist.collections,
		subscribed: state.persist.user.subscribed,
		unreadComments: state.persist.unreadComments,
		viewport: state.app.viewport
	})),
	translate('general'),
	withRouter
)

export default enhance(SiteSettingsOld)
